import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HardCodedConfigService } from '@services/util/hard-coded-config.service';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

interface BuildingOption {
  label: string;
  value: string | null;
}

@Component({
  selector: 'app-building-filter',
  standalone: true,
  imports: [CommonModule, SelectButtonModule, FormsModule, TranslateModule],
  template: `
    <p-selectButton
      [options]="buildingOptions"
      [(ngModel)]="selectedBuilding"
      (onChange)="onBuildingChange()"
      optionLabel="label"
      optionValue="value"
      styleClass="text-sm"
      class="mb-2"
    >
      <!-- Custom template to ensure translation -->
      <ng-template
        let-item
        pTemplate="item"
      >
        <span>{{ item.label === 'common.all' ? (item.label | translate) : item.label }}</span>
      </ng-template>
    </p-selectButton>
  `
})
export class BuildingFilterComponent implements OnInit {
  @Input() selectedBuilding: string | null = null;
  @Output() buildingSelected = new EventEmitter<string | null>();

  buildingOptions: BuildingOption[] = [];

  constructor(
    private readonly translateService: TranslateService,
    private readonly hardcodedConfig: HardCodedConfigService
  ) {}

  ngOnInit(): void {
    // Add 'All' as the first option
    this.buildingOptions = [{ label: 'common.all', value: null }];

    // Add buildings from config
    this.hardcodedConfig.BUILDING_CONFIG.forEach((building) => {
      this.buildingOptions.push({
        label: building.name,
        value: building.name
      });
    });
  }

  /**
   * Emit the selected building value when changed
   */
  onBuildingChange(): void {
    this.buildingSelected.emit(this.selectedBuilding);
  }
}
